import { http } from '../client';
import type { CallOptions, WriteOptions } from '../types';
import type { AddonsApi } from './addons';

// Paths mirror subsystems/platform/facade/adapters/admin-api/src/admin/addons.rs.
const seg = encodeURIComponent;
const rd = (o?: CallOptions) => ({ signal: o?.signal });
const wr = (o?: WriteOptions) => ({ signal: o?.signal, idempotencyKey: o?.idempotencyKey });

export const addonsHttp: AddonsApi = {
  getAddons: (opts) => http.get('api', '/addon-lifecycle', rd(opts)),
  requestAddonChange: (addon, body, opts) => http.post('api', `/addon-lifecycle/${seg(addon)}`, body, wr(opts)),
  listAddonEvents: (addon, query, opts) => http.get('api', `/addon-lifecycle/${seg(addon)}/events`, { query: { ...query }, ...rd(opts) }),
  replayAddonEvent: (addon, eventId, body, opts) => http.post('api', `/addon-lifecycle/${seg(addon)}/events/${seg(eventId)}/replay`, body, wr(opts)),
  getAddonPages: (addon, opts) => http.get('api', `/addon-pages/${seg(addon)}`, rd(opts)),
  getAddonMenu: (opts) => http.get('api', '/addon-menu', rd(opts)),
  // A read through POST (its body names the block and the filters).
  queryAddonBlock: (addon, body, opts) => http.post('api', `/addon-pages/${seg(addon)}/query`, body, rd(opts)),
  runAddonAction: (addon, action, body, opts) => http.post('api', `/addon-pages/${seg(addon)}/actions/${seg(action)}`, body, wr(opts)),
};
